import type { DevToolsMicroLabelProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsMicroLabel/index.types';
import {
  MICRO_LABEL,
} from 'Modules/softphone/components/SoftphoneDevTools/styles';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * DevToolsMicroLabel - The field name above a value
 *
 * Small, uppercase and tracked out, so a label/value pair reads as one unit
 * of data rather than as two lines of prose.
 */
export const DevToolsMicroLabel: React.FC<DevToolsMicroLabelProps> = ({
  children,
  className,
}) => <span className={cn('block', MICRO_LABEL, className)}>{children}</span>;
